import { formatTaskSpaceName } from "../../pages/TeamTasks/utils/taskDisplayName";

export function getTeamSpaceLabel(space) {
  if (!space) return "";
  if (space.type === "dm") {
    return space.dmPeerName || `Conversa #${space.id}`;
  }
  const taskName = formatTaskSpaceName(space);
  if (taskName) return taskName;
  const sid = space.id != null ? String(space.id) : "";
  return space.name || (space.slug ? `#${space.slug}` : sid ? `Canal ${sid}` : "Canal");
}
